import type { PaymentsToValidateEnumApi } from "@/modules/finances/paymentsToValidate/gateway/paymentsToValidateApi"
import type { PaymentToValidateFilterStatus } from "@/modules/finances/types/financesType"

export const paymentsToValidateKeys = {
  all: ["paymentsToValidate"] as const,
  paymentsToValidate: (
    api: PaymentsToValidateEnumApi,
    filters: {
      page: number
      pageSize: number
      sortBy: string | undefined
      sortOrder: string | undefined
      nameFilter: string | undefined
      status: PaymentToValidateFilterStatus | undefined
    },
  ) => [...paymentsToValidateKeys.all, api, filters] as const,
}
